'use strict';

class InPageNavigation {
  constructor(node) {
    this.rootElement = node;
    this.sectionElements = Array.from(this.rootElement.querySelectorAll('.c-tab-navigation-tablist__item'));
    this.subMenuElements = Array.from(this.rootElement.querySelectorAll('.has-submenu'));
    this.allSections = document.querySelectorAll('[id^=\'c\']');
    this.sectionElements.forEach((sectionElement) => sectionElement.addEventListener('click', this.onClick.bind(this)));
    this.subMenuElements.forEach((subMenuElement) => subMenuElement.addEventListener('click', this.openSubmenu.bind(this)));

    const observerOptions = {
      root: document,
      rootMargin: '0px',
      threshold: 0,
    }

    this.intersection = new IntersectionObserver(this.intersectionObserver.bind(this), observerOptions);
    this.allSections.forEach((section) => { this.intersection.observe(section) });

    this.visibleSections = new Set();
  }

  onClick(event) {
    this.sectionElements.forEach((sectionElement) => sectionElement.classList.remove('is-active'));
    const el = event.target.closest('.c-tab-navigation-tablist__item');
    if (!el.classList.contains('is-active')) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  }

  intersectionObserver(entries) {
    entries.forEach((entry) => {
      const elementId = entry.target.id;
      const sectionTarget = document.querySelector(`a[href$="#${elementId}"]`);

      if (!sectionTarget) {
        return;
      }

      if (sectionTarget.parentElement.classList.contains('c-button')) {
        return;
      }

      if (entry.isIntersecting) {
        this.visibleSections.add(entry.target);
      } else {
        this.visibleSections.delete(entry.target);
      }
    });

    this.updateNavigationItems();
  }

  updateNavigationItems() {
    this.sectionElements.forEach((el) => el.classList.remove('is-active'));
    let closestElement = null;
    let closestElementDistance = Infinity;

    this.visibleSections.forEach((section) => {
      const distance = section.getBoundingClientRect().top;
      if (Math.abs(distance) < closestElementDistance) {
        closestElementDistance = Math.abs(distance);
        closestElement = section;
      }
    });

    if (!closestElement) {
      const midpoint = window.innerHeight / 2;
      closestElement = Array.from(this.allSections)
        .filter((s) => s.getBoundingClientRect().top < midpoint)
        .at(-1);
    }

    if (!closestElement) {
      return;
    }

    const target = document.querySelector(`a[href$="#${closestElement.id}"]`);
    if (target && !target.parentElement.classList.contains('c-button')) {
      target.parentElement.classList.add('is-active');
    }
  }

  openSubmenu(event) {
    event.preventDefault();
    const el = event.target;
    const icon = el.querySelector('.c-icon') || el.closest('.c-anchor').querySelector('.c-icon');
    const submenu = el.closest('.c-tab-navigation-tablist__item').querySelector('.c-tab-navigation-tablist__item--subpages-list');

    if (el && icon.classList.contains('bi-chevron-down')) {
      icon.classList.remove('bi-chevron-down');
      icon.classList.add('bi-chevron-up');
    } else {
      icon.classList.add('bi-chevron-down');
      icon.classList.remove('bi-chevron-up');
    }

    if(submenu.classList.contains('is-hidden')) {
      submenu.classList.remove('is-hidden');
    } else {
      submenu.classList.add('is-hidden');
    }
  }
}

const inPageNavigation = document.querySelector('.c-local-navigation--horizontal');
new InPageNavigation(inPageNavigation);

